import styled, { css } from 'styled-components'
import { Row } from '@sainsburys-tech/bolt'
import { remCalculator } from '../../../helpers/theming/utilities'

export const Wrapper = styled(Row)`
  text-decoration: none;
  justify-content: flex-start;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;

  ${(props) =>
    css`
      margin-bottom: ${remCalculator(props.theme.size.spacing.lg)};
    `}
`
